// Define a v-feature-flagged directive for feature flag checking.
import { ObjectDirective, DirectiveBinding } from 'vue';
import { Feature } from '@/models';
import { useSessionStore } from '@/stores/session.store';

const isEnabled = (sessionStore: ReturnType<typeof useSessionStore>, key: string): boolean =>
  sessionStore.features.some((f: Feature) => f.key === key && f.enabled);

const directive: ObjectDirective<HTMLElement> = {
  mounted: (el, binding: DirectiveBinding) => {
    const sessionStore = useSessionStore();
    const placeholder = document.createComment(' ');

    const evaluate = () => {
      if (!isEnabled(sessionStore, binding.value)) {
        el.parentNode?.replaceChild(placeholder, el);
      } else if (placeholder.parentNode) {
        placeholder.parentNode.replaceChild(el, placeholder);
      }
    };

    evaluate();
    // Subscribe so the element is reactively shown/hidden when feature flags
    // are toggled (e.g. after a domain-level feature change re-fetches orgs).
    (el as any)._featureUnwatch = sessionStore.$subscribe(evaluate);
  },
  unmounted: (el) => {
    if ((el as any)._featureUnwatch) {
      (el as any)._featureUnwatch();
    }
  }
};

export default directive;
